import { io } from "socket.io-client";
import BASE_URL from "./env.js";

let socket = null;

const getSocketOrigin = () => {
  if (!BASE_URL) return "http://localhost:7000";
  try {
    const parsed = new URL(BASE_URL);
    return parsed.origin;
  } catch (e) {
    return BASE_URL.replace(/\/api\/?$/, "");
  }
};

export const getSocket = () => {
  const token = localStorage.getItem("token");
  const serverOrigin = getSocketOrigin();

  if (!socket) {
    socket = io(serverOrigin, {
      auth: {
        token: token || "",
      },
      transports: ["websocket", "polling"],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });

    socket.on("connect", () => {
      // console.log("[Socket.IO] Connected to server:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.warn("[Socket.IO] Connection error:", err.message);
    });
  } else if (token && socket.auth?.token !== token) {
    socket.auth = { token };
    if (socket.connected) {
      socket.disconnect().connect();
    }
  }

  if (socket && !socket.connected) {
    socket.connect();
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
